__turbopack_context__.v({
  "additionalFilters": "I9BJYG_additionalFilters",
  "classTypeFilter": "I9BJYG_classTypeFilter",
  "compactClassTypeFilter": "I9BJYG_compactClassTypeFilter",
  "desktopSearch": "I9BJYG_desktopSearch",
  "hideWhileMobileSearchOpen": "I9BJYG_hideWhileMobileSearchOpen",
  "locationFilter": "I9BJYG_locationFilter",
  "mobileSearch": "I9BJYG_mobileSearch",
  "mobileSearchToggle": "I9BJYG_mobileSearchToggle",
  "periodControls": "I9BJYG_periodControls",
  "periodFrame": "I9BJYG_periodFrame",
  "primaryFilters": "I9BJYG_primaryFilters",
  "toolbar": "I9BJYG_toolbar",
  "toolbarRow": "I9BJYG_toolbarRow",
  "wideInstructorFilter": "I9BJYG_wideInstructorFilter",
});
